/**
 * The prebuilt Gemini Live voices offered for a bot. The voice is chosen per bot in its
 * settings and sent with the ephemeral-token request; the server accepts only this list.
 */
export const LIVE_VOICES = [
  { id: "Kore", name: "Kore", gender: "female" },
  { id: "Aoede", name: "Aoede", gender: "female" },
  { id: "Puck", name: "Puck", gender: "male" },
  { id: "Charon", name: "Charon", gender: "male" },
] as const;

export type LiveVoice = (typeof LIVE_VOICES)[number];
export type LiveVoiceId = LiveVoice["id"];
export type LiveVoiceGender = LiveVoice["gender"];

export const LIVE_DEFAULT_VOICE_ID: LiveVoiceId = "Kore";

export function isLiveVoiceId(value: unknown): value is LiveVoiceId {
  return typeof value === "string" && LIVE_VOICES.some((voice) => voice.id === value);
}

export function resolveLiveVoiceId(value: unknown): LiveVoiceId {
  return isLiveVoiceId(value) ? value : LIVE_DEFAULT_VOICE_ID;
}
